import React from 'react';
import { Link } from 'react-router-dom';

function footer() {
  return (
    <>
      <div
        class="container-fluid bg-secondary text-light footer my-6 mb-0 py-6 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-3 col-md-6">
              <h4 class="text-white mb-4">Get In Touch</h4>
              <h2 class="mb-4 text-white">
                Rev<span class="text-primary">tech</span>
              </h2>
              <p class="mb-2">
                <i class="fa fa-map-marker-alt me-3"></i>2933 Stone Branch Drive,
                Leander, TX -78641
              </p>
              <p class="mb-2">
                <i class="fa fa-phone-alt me-3"></i>+669 266 8066
              </p>
              <p class="mb-2">
                <a href='mailto:hr@revtechusa.com' className='text-white'><i class="fa fa-envelope me-3"></i>hr@revtechusa.com</a>
              </p>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-light mb-4">Quick Links</h4>
              <Link className="btn btn-link" to="/about">
                About Us
              </Link>
              <Link className="btn btn-link" to="/contact">
                Contact Us
              </Link>
              <Link className="btn btn-link" to="/services">
                Our Services
              </Link>
              <Link className="btn btn-link" to="/terms-and-conditions">
                Terms & Condition
              </Link>
              <Link className="btn btn-link" to="/support">
                Support
              </Link>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-light mb-4">Popular Links</h4>
              <Link className="btn btn-link" to="/about">
                About Us
              </Link>
              <Link className="btn btn-link" to="/contact">
                Contact Us
              </Link>
              <Link className="btn btn-link" to="/services">
                Our Services
              </Link>
              <Link className="btn btn-link" to="/terms-and-conditions">
                Terms & Condition
              </Link>
              <Link className="btn btn-link" to="/support">
                Support
              </Link>
            </div>
            <div class="col-lg-3 col-md-6">
              <h4 class="text-light mb-4">Newsletter</h4>
              <form action="">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control p-3 border-0"
                    placeholder="Your Email Address"
                  />
                  <button class="btn btn-primary">Sign Up</button>
                </div>
              </form>
              <h6 class="text-white mt-4 mb-3">Follow Us</h6>
              <div class="d-flex pt-2">
                <a class="btn btn-square btn-outline-light me-1" href="">
                  <i class="fab fa-twitter"></i>
                </a>
                <a class="btn btn-square btn-outline-light me-1" href="">
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a class="btn btn-square btn-outline-light me-1" href="">
                  <i class="fab fa-youtube"></i>
                </a>
                <a class="btn btn-square btn-outline-light me-0" href="">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default footer;
